export default __webpack_public_path__ + "static/media/illustration-empty.e3122ec2.svg";